import React, {useEffect} from "react";
import {useMediaPredicate} from "react-media-hook";

let Theme = (props) => {
    const preferredTheme = useMediaPredicate("(prefers-color-scheme: dark)") ? "dark" : "light";

    useEffect(()=>{
        document.getElementById('root').setAttribute('scheme', props.scheme);
    }, [props.scheme])

    useEffect(()=>{
        if (!props.scheme) {
            document.getElementById('root').setAttribute('scheme', preferredTheme);
        }
    })

    return(
        <div style={{height:"100%"}}>
            {props.children}
        </div>
    )
}
export default Theme;